import {
  AUTH,
  LOGIN_USER,
  LOGIN_FAILED,
  LOGOUT_USER,
  UPDATE_MESSAGE,
} from "./types";
import axios from "../services/axios";

export function getAuth() {
  return async function (dispatch) {
    try {
      const response = await axios.get("/members/me");
      dispatch({
        type: AUTH,
        payload: {
          user: response.data.user,
          alert: null,
        },
      });
    } catch (e) {
      console.log(e.message);
    }
  };
}

export function loginUser(email, password) {
  return async function (dispatch) {
    return axios
      .post("/login", { email, password })
      .then((response) => {
        // Save JWT token & use it for protected endpoints in between sessions
        dispatch({
          type: LOGIN_USER,
          payload: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          const fail_message = error.response.data.message;
          dispatch({
            type: LOGIN_FAILED,
            payload: { fail_message },
          });
        } else if (error.request) {
          dispatch({
            type: LOGIN_FAILED,
            payload: { fail_message: "Login failed. Please try again." },
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
          dispatch({
            type: LOGIN_FAILED,
            payload: { fail_message: "Login failed. Please try again." },
          });
        }
      });
  };
}

export function forgotPassword(email) {
  return async function (dispatch) {
    return axios
      .post("/forgot_password", { email })
      .then((resp) => {
        dispatch({
          type: UPDATE_MESSAGE,
          payload: {
            success_message:
              "If your email exists in our database, we will send you a password-reset link.",
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: UPDATE_MESSAGE,
          payload: {
            fail_message: "There was an error. Please try again.",
          },
        });
      });
  };
}

export function resetPassword(password, token) {
  return async function (dispatch) {
    return axios
      .post("/reset_password", { password, token })
      .then((resp) => {
        if (resp.status >= 400) {
          dispatch({
            type: UPDATE_MESSAGE,
            payload: { fail_message: `Error: ${resp.data.message}` },
          });
        } else {
          dispatch({
            type: LOGIN_USER,
            payload: resp.data,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: UPDATE_MESSAGE,
          payload: {
            fail_message: "There was an error. Please try again.",
          },
        });
      });
  };
}

export function logout() {
  return async function (dispatch) {
    await axios.post("/logout");
    dispatch({
      type: LOGOUT_USER,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js